<template>
    <div class="w-full">
        <form id="smmr-form" class="my-2 mx-4 border border-gray-300 bg-gray-100" @submit.prevent="update">
            <h2 class="text-green-600 text-2xl leading-10 pr-8 ml-8 mt-8 text-left">English Test record {{ itemIndex + 1 }} <span v-if="itemIndex === 0"> - most recent</span></h2>
            <div class="flex flex-wrap p-8" @change="dirtyForm()" @keydown="dirtyForm">
                <select-input v-model="form.testTaken" class="pr-6" label="* Test Taken"
                              :error="form.errors?.testTaken"
                              @update:modelValue="value = $event"
                >
                    <option value="">Please select the test taken</option>
                    <option value="IELTS">IELTS</option>
                    <option value="LanguageCert Academic SELT">LanguageCert Academic SELT</option>
                    <option value="Pearson Test for English">Pearson Test for English</option>
                    <option value="Trinity College London Integrated Skills in English - ISE III">Trinity College London Integrated Skills in English - ISE III</option>
                    <option value="Other">Other</option>
                </select-input>
                <text-input v-model="form.reportFormNumber"
                            :error="form.errors?.reportFormNumber"
                            class="pr-6"
                            label="Test Report Form Number / Score Report Code" @update:modelValue="value = $event"
                />
                <text-input v-model="form.testDate"
                            type="date"
                            :error="form.errors?.testDate"
                            class="pr-6" label="Test Date" @update:modelValue="value = $event"
                />
                <text-input v-model="form.listeningResult"
                            :error="form.errors?.listeningResult"
                            class="pr-6" label="Listening Result"
                            @update:modelValue="value = $event"
                />

                <text-input v-model="form.readingResult"
                            :error="form.errors?.readingResult"
                            class="pr-6" label="Reading Result"
                            @update:modelValue="value = $event"
                />

                <text-input v-model="form.writingResult"
                            :error="form.errors?.writingResult"
                            class="pr-6" label="Writing Result"
                            @update:modelValue="value = $event"
                />

                <text-input v-model="form.speakingResult"
                            :error="form.errors?.speakingResult"
                            class="pr-6" label="Speaking Result"
                            @update:modelValue="value = $event"
                />

                <text-input v-model="form.overallResult"
                            :error="form.errors?.overallResult"
                            class="pr-6" label="Overall Result"
                            @update:modelValue="value = $event"
                />

                <textarea-input v-model="form.notes"
                                class="w-full-i bg-green-200 padding-2 mb-4"
                                label="Notes or extenuating circumstances"
                                rows="2"
                                @update:modelValue="value = $event"
                />
            </div>
            <div class="items-center">
                <div v-if="successMessage" class="mx-8 success-message">{{ successMessage }}</div>

                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error mx-8">There were some validation issues, please check the fields above</p>
                </div>
                <div class="flex flex-wrap justify-center">
                    <application-component-save-button :disabled="formDirty" class="relative flex btn-green -ml-0 w-3/4 sm:w-52 justify-center sm:inline-block text-center" type="submit">
                        Save this record
                        <div v-if="loading" class="lds-ring-container absolute top-2 left-2">
                            <div class="lds-ring"><div /><div /><div /><div /></div>
                        </div>
                    </application-component-save-button>
                    <button class="w-3/4 sm:w-52 mt-0 sm:mt-8 my-8 sm:ml-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" type="button" @click="removeRecord">
                        Remove this record
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import TextInput from '../../../shared/TextInput.vue'
import SelectInput from '../../../shared/SelectInput.vue'
import TextareaInput from '../../../shared/TextareaInput.vue'
import ApplicationComponentSaveButton from '../../../shared/ApplicationComponentSaveButton.vue'

export default {
  components: {ApplicationComponentSaveButton, TextareaInput, SelectInput, TextInput},
  props: {
    applicationReference: String,
    testResult: Object,
    itemIndex: Number,
  },
  data() {
    return {
      form: {
        reference: this.testResult.reference,
        testTaken: this.testResult.testTaken,
        reportFormNumber: this.testResult.reportFormNumber,
        testDate: this.testResult.testDate,
        listeningResult: this.testResult.listeningResult,
        readingResult: this.testResult.readingResult,
        writingResult: this.testResult.writingResult,
        speakingResult: this.testResult.speakingResult,
        overallResult: this.testResult.overallResult,
        notes: this.testResult.notes,
        errors: {},
      },
      formDirty: false,
      loading: false,
      successMessage: '',
      serverError: '',
    }
  },
  computed: {
    validationErrors: {
      get: function() {
        return this.form.errors
      },
      set: function(newValue) {
        for (const key in newValue)
        {
          this.form.errors[key] = newValue[key].join(' ')
        }
      },
    },
  },
  methods: {
    removeRecord() {
      if (confirm('Are you sure you want to remove this English Test Record?')) {
        if (this.form.reference !== null) {
          this.loading = true
          this.$store.dispatch('deleteEnglishTest', {
            applicationReference: this.applicationReference,
            englishTestReference: this.form.reference,
          }).then(response => {
            this.loading = false
            this.form.errors = {}
            this.successMessage = response.data
            this.$emit('delete', this.itemIndex)
            window.location.search += '&section=englishTestShow'
          }).catch(error => {
            this.loading = false
            this.form.errors = Object.values(error)
            this.successMessage = ''
          })
        } else {
          this.$emit('delete', this.itemIndex)
          window.location.search += '&section=englishTestShow'
        }
      }
    },
    update() {
      this.loading = true
      const action = this.form.reference === null? 'createEnglishTest' : 'updateEnglishTest'
      this.$store.dispatch(action, {
        applicationReference: this.applicationReference,
        englishTest: this.form,
      }).then(response => {
        this.loading = false
        this.form.errors = {}
        this.successMessage = response.data.message
        this.form.reference = response.data.reference
        this.formDirty = false
        window.location.search += '&section=englishTestShow'
      }).catch(error => {
        this.loading = false
        this.form.errors = error.response.data.errors
        this.validationErrors = error.response.data.errors
        this.successMessage = ''
      })
    },
    dirtyForm() {
      this.formDirty = true
      this.successMessage = ''
    },
  },
}
</script>